/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Initial hide
function hideSizeSwatches() {
    document.querySelectorAll('.block-swatch-list label[title="Select a Size"], .block-swatch-list label[data-title="Select a Size"]').forEach(label => {
        const blockSwatch = label.closest(".block-swatch");
        if (blockSwatch) {
            blockSwatch.style.setProperty('display', 'none', 'important');
            blockSwatch.style.setProperty('visibility', 'hidden', 'important');
            blockSwatch.style.setProperty('opacity', '0', 'important');
            blockSwatch.style.setProperty('pointer-events', 'none', 'important');
        }
    });
}

// Run on page load
document.addEventListener("DOMContentLoaded", hideSizeSwatches);

// Run when variant changes (using MutationObserver to watch for DOM changes)
const observer = new MutationObserver(hideSizeSwatches);

// Start observing the document with the configured parameters
document.addEventListener("DOMContentLoaded", () => {
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
});